export const formatCurrency = (amount) => {

  const cleaned = String(amount ?? "0").replace(/,/g, "");
  const value = parseFloat(cleaned);

  const safeValue = isNaN(value) ? 0 : value;

  return safeValue.toLocaleString("en-KE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};